
import { Record } from 'immutable';
import { actionTypes } from './layout.actions';


/**
 * Keep track of an item in the side nav bar.
 * navItemType:  string.  Default: null.  What type of item are we keeping track of?  'provider' and 'create-new-location' are the currently supported choices.
 * provId:  number.  If navItemType is 'provider', this will be the provider id.  If navItemType is 'create-new-location', this will be null.
 */
export const NavDetail = Record({
  navItemType: null,
  provId:  null
});

/**
 * Keep track of the keys pressed during keyboard navigation
 * at certain strategic points.
 */
export const LayoutState = Record({
  /** bool.  Default: true.  If true the side nav will not be shown on mobile. */
  navbarCollapsed: true,
  /** bool.  Default: false.  If true the side nav will not be shown for the desktop display. */
  desktopNavCollapsed: false,
  /** number.  Default:  null.  Represents the code of the keystroke from the side nav bar that we care about.  This comes from the onKeyDown event:  e.keyCode || e.which */
  navFromKey: null,
  /** navDetail:  object.  Default:  new NavDetail.  Contains details about the item in the side nav bar that corresponds to the navFromKey keystroke.  (See definition of NavDetail record.) */
  navDetail: new NavDetail(),
  /** tabFromKey:  number.  Default:  null.  Represents the code of the keystroke from the tab control that we care about.  This comes from the onKeyDown event:  e.keyCode || e.which */
  tabFromKey: null,
  /** tabId:  string.  Default:  null.  The id of the tab that was affected by the tabFromKey keystroke.  'tab-attributes', 'tab-services-provided', and 'tab-pending-updates' are the currently supported choices. */
  tabId: null
});


export const layoutReducer = (state = new LayoutState(), action) => {
  switch (action.type) {
    case actionTypes.EXPAND_NAVBAR:
      return state.set('navbarCollapsed', false);
    case '@@router/LOCATION_CHANGE':
    case actionTypes.COLLAPSE_NAVBAR:
      return state.set('navbarCollapsed', true);
    case actionTypes.EXPAND_DESKTOP_NAVBAR:
      return state.set('desktopNavCollapsed', false);
    case actionTypes.COLLAPSE_DESKTOP_NAVBAR:
      return state.set('desktopNavCollapsed', true);
    case actionTypes.SET_NAV_FROM_KEY:
      if ( action.keycode === 13 ) {
        return state.set('navFromKey', action.keycode)
                    .set('navDetail', action.navdetail);
      }
      return state;
    case actionTypes.UNSET_NAV_FROM_KEY:
      return state.set('navFromKey', null)
                  .set('navDetail', null);
    case actionTypes.SET_TAB_FROM_KEY:
      return state.set('tabFromKey', action.keycode)
                  .set('tabId', action.tabname);
    case actionTypes.UNSET_TAB_FROM_KEY:
      return state.set('tabFromKey', null)
                  .set('tabId', null);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/layout/layout.reducer.js